export default __webpack_public_path__ + "static/media/devSignIn.81686fca.png";